/**
 * Full-screen branded-spinner overlay, shown whenever the app is waiting on a
 * mutation or an upload (see lib/busy + api.ts). Appears only after a short delay
 * so a fast call never flashes it, and sits above sheets so the person always
 * sees that something is happening during a processing delay.
 */
import { useEffect, useState } from 'react';
import { subscribeBusy } from '../lib/busy';
import { Spinner } from './ui';

export function GlobalBusy() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    let timer: number | undefined;
    const unsub = subscribeBusy((active) => {
      if (active) {
        if (timer === undefined) {
          timer = window.setTimeout(() => setShow(true), 250);
        }
      } else {
        if (timer !== undefined) { window.clearTimeout(timer); timer = undefined; }
        setShow(false);
      }
    });
    return () => { if (timer !== undefined) window.clearTimeout(timer); unsub(); };
  }, []);

  if (!show) return null;
  return (
    <div className="busy-overlay" aria-live="polite" aria-busy="true">
      <Spinner label="Working…" />
    </div>
  );
}
